import { resources, dropdownOptions } from "../Resources/SharedResources";
import { ROUTES, getRoutePath } from "../Resources/routes";
import { useState } from "react";
import DropdownMenu from "./DropdownMenu";

function TopMenu({ langName }) {
    const lang = langName;
    const [menuOpen, setMenuOpen] = useState(false);

    // Get current page path
    let pagePath = window.location.pathname.split(lang)[1];
    pagePath = pagePath?.split("/")[1] || ROUTES.HOME;

    const menuItems = [
        { route: ROUTES.HOME, label: resources[lang].Home },
        {
            route: ROUTES.ABOUT,
            label: resources[lang].About,
            dropdown: dropdownOptions[lang].about,
        },
        {
            route: ROUTES.SERVICES,
            label: resources[lang].Services,
            dropdown: dropdownOptions[lang].services,
        },
        {
            route: ROUTES.INDUSTRIES,
            label: resources[lang].Industries,
            dropdown: dropdownOptions[lang].industries,
        },
        { route: ROUTES.CONTACT, label: resources[lang].Contact },
    ];

    return (
        <nav className="main-nav">

            <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? "×" : "☰"}
            </button>

            <nav className="desktop-nav-container">
                {menuItems.map((item) => (
                    <DropdownMenu
                        key={item.route}
                        label={item.label}
                        link={getRoutePath(item.route, lang)}
                        items={item.dropdown}
                        pagePath={pagePath}
                    />
                ))}
            </nav>


            <div className={`mobile-nav-container ${menuOpen ? "show" : ""}`}>
                {menuItems.map((item) => (
                    <a
                        key={item.route}
                        href={getRoutePath(item.route, lang)}
                        className={pagePath === item.route ? "current" : ""}
                        onClick={() => setMenuOpen(false)}
                    >
                        {item.label}
                    </a>
                ))}
            </div>
        </nav>
    );
}

export default TopMenu;
